import { type Card, RANK_NAMES, SUIT_NAMES, SUIT_SYMBOLS, type Suit, printedSuitOf, rankOf } from '@euchre/core';
import { h } from '../dom.js';

export const isRed = (s: Suit) => s === 'H' || s === 'D';

export function cardName(card: Card): string {
  return `${RANK_NAMES[rankOf(card)]} of ${SUIT_NAMES[printedSuitOf(card)]}`;
}

export function suitGlyph(suit: Suit, extra = ''): HTMLSpanElement {
  return h('span', { class: `suit-glyph ${isRed(suit) ? 'red' : 'black'} ${extra}`, text: SUIT_SYMBOLS[suit] });
}

interface CardOpts {
  onclick?: () => void;
  state?: 'playable' | 'dimmed' | 'selected' | 'plain';
  small?: boolean;
  title?: string;
}

export function cardFace(card: Card, opts: CardOpts = {}): HTMLElement {
  const suit = printedSuitOf(card);
  const rank = rankOf(card);
  const sym = SUIT_SYMBOLS[suit];
  const face = rank === 'J' || rank === 'Q' || rank === 'K';
  const classes = ['card', 'face', isRed(suit) ? 'red' : 'black', opts.small ? 'small' : '', opts.state ? `is-${opts.state}` : '', face ? 'court' : ''];
  const inner = [
    h('span', { class: 'idx tl' }, h('span', { class: 'rank', text: rank }), h('span', { class: 'pip', text: sym })),
    face
      ? h('span', { class: 'cc court-frame' }, h('span', { class: 'court-letter', text: rank }), h('span', { class: 'court-suit', text: sym }))
      : h('span', { class: `cc ${rank === 'A' ? 'ace' : 'spot'}`, text: sym }),
    h('span', { class: 'idx br' }, h('span', { class: 'rank', text: rank }), h('span', { class: 'pip', text: sym })),
  ];
  const label = cardName(card);
  if (opts.onclick) {
    return h(
      'button',
      {
        class: classes.join(' '),
        type: 'button',
        onclick: opts.onclick,
        disabled: opts.state === 'dimmed',
        title: opts.title ?? label,
        attrs: { 'aria-label': opts.title ?? label },
        dataset: { card },
      },
      inner,
    );
  }
  return h('div', { class: classes.join(' '), title: opts.title ?? label, attrs: { role: 'img', 'aria-label': label }, dataset: { card } }, inner);
}

export function cardBack(small = false): HTMLElement {
  return h('div', { class: `card back${small ? ' small' : ''}`, attrs: { 'aria-hidden': 'true' } });
}
